import React from 'react';

// Cut-gem glass panel: 1px champagne frame that follows the chamfer, glass (or solid ink) face inside.
export const Cut = ({ size = 'md', glass = true, active = false, glow = false, className = '', innerClassName = '', children, ...rest }) => {
  const frame = (
    <div className={`th-frame th-cut th-cut-${size} ${active ? 'is-active' : ''} ${glow && !active ? '' : ''} ${className}`} {...rest}>
      <div className={`th-cut th-cut-${size} ${glass ? 'th-glass' : 'th-solid'} ${innerClassName}`}>{children}</div>
    </div>
  );
  return glow ? <div className="th-glow">{frame}</div> : frame;
};

// Uppercase tracked action on a chamfered face. One primary per view; everything else ghost or text.
export const ThButton = ({ variant = 'ghost', size = 'sm', className = '', children, ...rest }) => {
  if (variant === 'primary') {
    return <button type="button" className={`th-cut th-cut-${size} th-btn th-btn-primary ${className}`} {...rest}>{children}</button>;
  }
  if (variant === 'text') {
    return <button type="button" className={`th-btn th-btn-text ${className}`} {...rest}>{children}</button>;
  }
  return (
    <span className={`th-frame th-cut th-cut-${size} inline-flex ${className}`}>
      <button type="button" className={`th-cut th-cut-${size} th-btn th-btn-ghost`} {...rest}>{children}</button>
    </span>
  );
};

export const Label = ({ ruled = false, className = '', children, ...rest }) => (
  <span className={`th-label ${ruled ? 'th-ruled' : ''} ${className}`} {...rest}>{children}</span>
);

// "Ayesha & Omar" → Cormorant capitals with the italic champagne ampersand.
export const Names = ({ text = '', className = '', ...rest }) => {
  const parts = String(text).split(/\s*(?:&|\+|\band\b)\s*/i).filter(Boolean);
  return (
    <span className={`th-display uppercase ${className}`} {...rest}>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="th-amp normal-case"> &amp; </span>}
          {p}
        </React.Fragment>
      ))}
    </span>
  );
};
